export const FAVORITE_BOARD = 'events/FAVORITE_BOARD';

/**
 * @param board
 * @return {{type: string, payload: { board, intl, messages }}
 */
export const favoriteBoard = (board, intl, messages) => ({
  type: FAVORITE_BOARD,
  payload: { board, intl, messages },
});
